import React from "react";
import {
  ClientsAndGroupsSelectDialog,
  EnrollDialogProps,
  EnrollmentSelected,
} from "../groups/ClientsAndGroupsSelectDialog";
import { EnrollDateDialog } from "../dialog/EnrollDateDialog";
import { ProgramProfileDto } from "@growth-machine-llc/stridist-api-client";

export function useEnrollClients(
  program: ProgramProfileDto,
  clientsCount: number,
  groupsCount: number,
) {
  const [enrollDialogOpen, setEnrollDialogOpen] = React.useState(false);
  const [enrollDateDialogOpen, setEnrollDateDialogOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<EnrollmentSelected>({});

  const openEnroll = React.useCallback((event?: React.MouseEvent) => {
    event?.stopPropagation();
    setEnrollDialogOpen(true);
  }, []);

  const handleCloseEnrollDialog = React.useCallback(() => {
    setEnrollDialogOpen(false);
  }, []);

  const handleCloseEnrollDateDialog = React.useCallback(() => {
    setEnrollDateDialogOpen(false);
  }, []);

  const handleSelected: EnrollDialogProps["onSelected"] = React.useCallback(
    (selected) => {
      setSelected(selected);
      setEnrollDateDialogOpen(true);
    },
    [],
  );

  const dialogs = (
    <>
      {enrollDialogOpen && (
        <ClientsAndGroupsSelectDialog
          open={true}
          onClose={handleCloseEnrollDialog}
          program={program as ProgramProfileDto}
          clientsCount={clientsCount}
          groupsCount={groupsCount}
          onSelected={handleSelected}
        />
      )}

      {enrollDateDialogOpen &&
        (selected.clients?.length || selected.groups?.length) && (
          <EnrollDateDialog
            open
            onClose={handleCloseEnrollDateDialog}
            program={program as ProgramProfileDto}
            selected={selected}
          />
        )}
    </>
  );

  return {
    openEnroll,
    dialogs,
  };
}
